import React, { useState } from "react";
import { noYesOptions } from "../../../../Options/commonOptions";
import {
  contractureAreas,
  leftRightOptions,
} from "../../../../Options/systemicExamOptions";
import DeselectableRadioGroup from "../../../../../../blocks/FormItems/DeselectableRadioGroup";
import { Checkbox, Form } from "antd";
import DynamicInputFields from "../../../../../../blocks/FormItems/DynamicInputFields";

const Contractures = ({ context, form }) => {
  const [refresh, setRefresh] = useState(false);
  const showOthers = ![false, undefined, null]?.includes(
    form.getFieldValue(["contractures", "others"])
  );
  return (
    <>
      <DeselectableRadioGroup
        name={["contractures", "status"]}
        label={"Contractures"}
        options={noYesOptions}
        form={form}
        setRefresh={setRefresh}
      />
      {form.getFieldValue(["contractures", "status"]) === "yes" && (
        <div className="subsection-card">
          {contractureAreas.map((area) => (
            <DeselectableRadioGroup
              name={["contractures", area.toLowerCase()]}
              label={area}
              options={leftRightOptions}
              form={form}
            />
          ))}
          <Form.Item name={["contractures", "others"]} valuePropName="checked">
            <Checkbox onChange={() => setRefresh((prev) => !prev)}>
              Others
            </Checkbox>
          </Form.Item>
          {showOthers && (
            <DynamicInputFields
              field_key={["contractures", "others"]}
              form={form}
              inputStyle={{ maxWidth: 800 }}
            />
          )}
        </div>
      )}
    </>
  );
};
export default Contractures;
